import React from 'react';
import { Helmet } from 'react-helmet';
import {
  defaultDescription,
  defaultKeywords,
} from 'HelperFunctions/defaultSEO';

const GlobalMetaData = ({ title, mainSetting, url }) => {
  const globalDescription = mainSetting.gaDescription;
  const globalKeywords = mainSetting.gaKeywords;

  return (
    <Helmet>
      {/* SEO Meta Tags */}
      <meta
        name='description'
        content={globalDescription || defaultDescription}
      />
      <meta name='keywords' content={globalKeywords || defaultKeywords} />
      {/* Open Graph Meta Tags */}
      <meta
        property='og:description'
        content={globalDescription || defaultDescription}
      />
      <title>{title}</title>
    </Helmet>
  );
};

export default GlobalMetaData;
